import React, { useEffect, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { actionListener } from '../../../utils/helpers';
import store from '../../../redux/store';
import styles from './styles';
import { useTranslation } from 'react-i18next';
import { snackbarShowMessage } from "../../../redux/actions/snackbarActions";
import {
  createSpecialEvent,
  setSpecificSpecialEventData,
} from './../../../redux/actions/newOperationHoursActions';
import { CREATE_SPECIAL_EVENT } from '../../../redux/action-types/new-operation-hours-types';
import { textToSnakeCase } from '../../../utils/utils';
import {
  setSelectedRangeDate,
  setSelectedStartDate,
} from '../../../redux/actions/newOperationHoursActions';
import RBISuccessPopup from '../../RBIMessagePopup/RBISuccessPopup';
import ShowErrorMessageModal from '../RestaurantDetails/ShowErrorMessageModal'

export default function (props: any) {
  const { t } = useTranslation();
  const classes = styles();
  const dispatch: any = useDispatch();

  const { specialEventReason, specialEventReasons, selectedStartDate, selectedEndDate, } = useSelector(
    (state: RootStateOrAny) => state.NewOperationHoursReducer,
  );
  const { RestaurantId } = useSelector(
    (state: RootStateOrAny) => state.RestaurantsReducer.entity,
  );
  const [successPopupModal, setSuccessPopupModal] = useState({
    isOpen: false,
    message: ''
  });
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [uploadErrors, setErrors] = useState()

  const handleSuccessCloseModal = () => {
    setSuccessPopupModal({
      isOpen: false,
      message: ''
    });
  }

  useEffect(() => {
    const unsubscribeSpecialEvent = actionListener(
      store,
      CREATE_SPECIAL_EVENT.SUCCESS,
      (result) => {
        RestaurantId ? dispatch(snackbarShowMessage(t('operationHours.saved'))) : setSuccessPopupModal({
          isOpen: true,
          message:  t('operationHours.success.pendingProcess') + ' ' + result?.payload?.data?.result?.referenceId
        });
        if (selectedStartDate && selectedEndDate && !RestaurantId) {
          dispatch(setSelectedRangeDate(selectedStartDate, selectedEndDate));
        } else if (selectedStartDate && !RestaurantId) {
          dispatch(setSelectedStartDate(selectedStartDate));
        }
      }
    );
    const unsubscribeSpecialEventzError = actionListener(
      store,
      CREATE_SPECIAL_EVENT.REJECTED,
      (errorData) => {
        const checkData = errorData?.payload?.error?.response?.data;
        if (checkData?.error_code === 'INTERNAL_SERVER_ERROR' && !(checkData?.error_description.some(obj => Object.keys(obj).includes('error_message')))) {
          setOpenErrorModal(true);
          setErrors(checkData);
        }
      }
    );
    return () => {
      unsubscribeSpecialEvent();
      unsubscribeSpecialEventzError();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStartDate, selectedEndDate]);

  const onSelectorChange = event => {
    dispatch(
      setSpecificSpecialEventData({ specialEventReason: event.target.value }),
    );
  };

  const handleOnClose = () => {
    dispatch(setSpecificSpecialEventData({ specialEventReason: null }));
    props.confirmationModalOpenHandler();
  };

  const handleOnSubmit = () => {
    dispatch(createSpecialEvent());
    dispatch(setSpecificSpecialEventData({ specialEventReason: null }));
    props.confirmationModalOpenHandler();
  };

  return (
    <>
      <Dialog
        maxWidth="md"
        open={props.confirmationModalOpen}
        aria-labelledby="max-width-dialog-title"
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
      >
        <DialogContent style={{ minHeight: '30vh' }}>
          <DialogTitle
            id="alert-dialog-title"
            className={classes.containerDialogTitle}
          >
            <div className={classes.divItems}>
              <Typography variant="h6">
                {t('operationHours.specialReason')}
              </Typography>
              <IconButton
                style={{ position: 'relative', marginLeft: '30px', padding: '0' }}
                onClick={handleOnClose}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </DialogTitle>
          <Grid
            container
            spacing={1}
            alignItems="center"
            className={classes.paddingBottom}
          >
            <FormControl variant="outlined" className={classes.fullWidth}>
              <Typography variant="subtitle1">
                {t('operationHours.specialReasonMessage')}
              </Typography>
              <Typography variant="subtitle1" className={classes.paddingBottom}>
                {t('operationHours.specialReasonMessage2')}
              </Typography>
              <Select
                style={{
                  marginLeft: '30px',
                  marginRight: '30px',
                  padding: '0',
                  marginBottom: '40px',
                }}
                value={specialEventReason}
                onChange={onSelectorChange}
              >
                {specialEventReasons?.map((e, i) => (
                  <MenuItem key={i} value={e.id}>
                    {t(`operationHours.specialReason.option.${textToSnakeCase(e.name)}`, e.name)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <div className={classes.buttonContainer}>
              <Button
                variant="outlined"
                color="primary"
                className={classes.button}
                onClick={handleOnClose}
              >
                {t('app.common.cancel')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={
                  !specialEventReason || specialEventReason === '' ? true : false
                }
                className={classes.button}
                onClick={handleOnSubmit}
              >
                {t('app.common.save')}
              </Button>
            </div>
          </Grid>
        </DialogContent>
      </Dialog>
      {successPopupModal.isOpen && <RBISuccessPopup isOpen={successPopupModal.isOpen} closeModal={handleSuccessCloseModal}
        message={successPopupModal.message} />}
      {openErrorModal && <ShowErrorMessageModal isOpen={openErrorModal} onClose={() => setOpenErrorModal(false)} errors={uploadErrors} />}
    </>
  );
}
